import React from 'react'
import MenuItem from 'material-ui/MenuItem'

const buildMenuItems = (resource) => {
  return [
    <MenuItem primaryText='Edit' key='edit' value={`/membership/institution-users/${resource.id}/edit`} />,
    <MenuItem primaryText='User' key='user' value={`/security/users/${resource.user_id}/edit`} />,
    <MenuItem primaryText='Institution' key='institution' value={`/membership/institutions/${resource.institution_id}/edit`} />
  ]
}

export default buildMenuItems
